import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { Spin } from 'ant-design-vue'
import { useRouter } from '@/hooks/useRouter'

type Props = {
    /** 标题 */
    title?: string,
    date?: string,
    /** 作者 */
    dept?: string,
    readyNum?: string | number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailNav',
  props: {
    title: null,
    date: null,
    dept: null,
    readyNum: null
  },
  setup(__props: any) {

const props = __props as { title?: string, date?: string, dept?: string, readyNum?: string | number };

const router = useRouter()




return { __sfc: true,router, props }
}

})